import React from 'react'
import WrapperFull from '../common/Wrapper-full'
import Submenu from './Submenu'
import Content from './Content'


const NotFound = () => {
    return (
        <WrapperFull renderButtonNav = {false}>
            <div className="container content">
                <Content />
                <Submenu />
            </div>
        </WrapperFull>
    )
}


export default NotFound


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/NotFound/index.js